import { serialize } from 'object-to-formdata';
import axios from 'axios';
import api from './api';

export default {
    loadInactiveCodes() {
        return axios.post('/profile/loadInactiveCodes/');
    },
    fetchImageList(profileId) {
        return axios.post('/profile/fetchImageList/', { profileId });
    },
    fetchUnits() {
        return axios.post('/profile/units/');
    },
    uploadFiche(oFile, prId) {
        const formData = new FormData();
        formData.append('fiche_data', oFile);
        formData.append('profileId', prId);
        return axios.post('/profile/uploadFiche/', formData);
    },
    uploadImageNew(file, profileId, isMain, onUploadProgress) {
        const payload = {
            profileId: profileId,
            image_data: file,
            type: 'Image',
            isMain: isMain ? 1 : 0,
        };

        const config = {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        };

        if (onUploadProgress) {
            config.onUploadProgress = onUploadProgress;
        }

        return axios.post('/profile/uploadImage/', serialize(payload), config);
    },
    removeImageById(imageId) {
        return axios.post('/profile/removeImageById/', { imageId });
    },
    setMainImage(imageId) {
        return axios.post('/profile/setMainImage/', { imageId });
    },
    uploadImage(oFile, prId, uploadType) {
        const formData = new FormData();
        formData.append('image_data', oFile);
        formData.append('profileId', prId);
        formData.append('type', uploadType);
        return axios.post('/profile/uploadImage/', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },
    uploadImageZip(file, employeeId) {
        const formData = new FormData();
        formData.append('employeeId', employeeId);
        formData.append('zip', file);
        return axios.post('/profile/importImageZip/', formData);
    },
    listInactive() {
        return axios.post('/profile/listInactive/');
    },
    activate(code) {
        return axios.post('/profile/activate/', { code });
    },
    fetchAllProfileGroups() {
        return axios.post('/profile/groups/');
    },
    fetchAllStockGroups() {
        return axios.post('/profile/stockgroups/');
    },
    fetchAllProfileSubGroups() {
        return axios.post('/profile/subgroups/');
    },
    fetchProfilesWithStock(payload) {
        api.cancelRequests();
        return axios.post('/profile/fetchProfilesWithStock/', payload);
    },
    updateProfileCountSequence(payload) {
        return axios.post('/profile/updateProfileCountSequence/', payload);
    },
    updateProfileCountLocation(payload) {
        return axios.post('/profile/updateProfileCountLocation/', payload);
    },
    updateProfileStock(payload) {
        return axios.post('/profile/updateProfileStock/', payload);
    },
    updateProfileSpareStock(payload) {
        return axios.post('/profile/updateProfileSpareStock/', payload);
    },
    updateProfileKeepStock(payload) {
        return axios.post('/profile/updateProfileKeepStock/', payload);
    },
    updateProfilePriceList(payload) {
        return axios.post('/profile/updateProfilePriceList/', payload);
    },
    updateProfileMinStock(payload) {
        return axios.post('/profile/updateProfileMinStock/', payload);
    },
    updateProfileMaxStock(payload) {
        return axios.post('/profile/updateProfileMaxStock/', payload);
    },
    updateProfileUnit(profileId, unitRef) {
        return axios.post('/profile/updateProfileUnit/', {
            profileId,
            unitRef,
        });
    },
    insertStockCount(payload) {
        return axios.post('/profile/insertStockCount/', payload);
    },
    exportProfileStock() {
        return api.createGetUrl('/profile/exportProfileStock/');
    },
    export() {
        return api.createGetUrl('/profile/export/');
    },
    insertWorkstationInventory(payload) {
        return axios.post('/profile/insertWorkstationInventory/', payload);
    },
    removeWorkstationInventory(payload) {
        return axios.post('/profile/removeWorkstationInventory/', payload);
    },
    fetchCurrentStockCount() {
        return axios.post('/profile/fetchCurrentStockCount/');
    },
    fetch(profileId) {
        return axios.post('/profile/fetch/', { profileId });
    },
    fetchByCode(code) {
        return axios.post('/profile/fetchByCode/', { code });
    },
    update(payload) {
        return axios.post('/profile/update/', payload);
    },
    updateTablet(payload) {
        return axios.post('/profile/updateTablet/', payload);
    },
    fetchProfileCodesStartingWith(start) {
        return axios.post('/profile/fetchProfileCodesStartingWith/', { start });
    },
    codeExists(code, exceptId) {
        return axios.post('/profile/codeExists/', { code, exceptId });
    },
    updateGroup(payload) {
        return axios.post('/profile/updateGroup/', payload);
    },
    insertGroup(payload) {
        return axios.post('/profile/insertGroup/', payload);
    },
    fetchGroup(groupId) {
        return axios.post('/profile/fetchGroup/', { profileGroupId: groupId });
    },
    deleteGroup(id) {
        return axios.post('/profile/deleteGroup/', { profileGroupId: id });
    },
    removeProfile(id) {
        return axios.post('/profile/remove/', { profileId: id });
    },
    fetchNextLoonlakwerkNr() {
        return axios.post('/profile/fetchNextLoonlakwerkNr/');
    },
    reset() {
        return axios.post('/profile/reset/');
    },
    import(resultArray) {
        return axios.post('/profile/import/', { resultArray });
    },
    list(code, description) {
        return axios.post('/profile/list/', { code, description });
    },
    isPowder(profileId) {
        return axios.post('/profile/isPowder/', { profileId });
    },
    updateBarcode(profileId, barcode) {
        return axios.post('/profile/updateBarcode/', {
            profileId,
            barcode,
        });
    },
    exportColumns() {
        return axios.post('/profile/exportColumns/');
    },
    activateMultiple(codes) {
        return axios.post('/profile/activateMultiple/', { codes });
    },
    fetchOrderHistory(profileId, queryParameters) {
        return axios.get(`[API]/profile/${profileId}/order-history`, {
            params: queryParameters,
        });
    },
    updateOrderHistoryRecord(profileId, recordId, body) {
        return axios.put(
            `[API]/profile/${profileId}/order-history/${recordId}`,
            body
        );
    },
};
